import { useAuth } from "@/hooks/use-auth";
import { ContentBox } from "@msuite/ui/content-box";
import React, { Activity } from "react";
import { PlanHeader } from "./plan-header";
import { PlanKanban } from "./plan-kanban";
import { usePlanStore } from "@/components/plan/store";
import { PlanCapacity } from "./plan-capacity";

export function Plan() {
	/** Store */
	const { organization } = useAuth();
	const mode = usePlanStore((state) => state.mode);

	if (!organization) return null;

	/** Render */
	return (
		<ContentBox
			bottomPadding="none"
			className="pr-0 relative"
			withBreadcrumbs={false}
		>
			<React.Fragment>
				<PlanHeader />
				{/* Both boards stay mounted and the inactive one is hidden, rather than the switch
				    tearing one down and building the other. A hidden boundary keeps its DOM and its
				    component state and runs no effects, so returning to the kanban costs a style
				    change instead of a rebuild of the week's columns and the project list. */}
				<Activity
					name="plan-kanban"
					mode={mode === "daily" ? "visible" : "hidden"}
				>
					<PlanKanban />
				</Activity>
				<Activity
					name="plan-capacity"
					mode={mode === "capacity" ? "visible" : "hidden"}
				>
					<PlanCapacity />
				</Activity>
			</React.Fragment>
		</ContentBox>
	);
}
